import React from 'react'
import './lib/i18n'

import { AppProvider } from './providers/app'
import { AppRoutes } from './routes'
import { Toaster } from 'Components/Elements/Toaster/Toaster'
import { SystemMessages } from 'Components/Elements/SystemMessages/SystemMessages'
import { useAppStore } from 'Stores/appStoreModuleFed'
import { CheqLoader } from '@clickcease/cc-client-components-lib'
import { SplitProvider } from './splitio'
import { initializeLogRocket } from './logRocketConfig'

function App() {
  initializeLogRocket()
  const { isAuthenticating } = useAppStore()

  return (
    <SplitProvider>
      <AppProvider>
        {isAuthenticating && <CheqLoader />}
        {<AppRoutes />} <Toaster />
        <SystemMessages />
      </AppProvider>
    </SplitProvider>
  )
}

export default App
